<div class="default-dialog">
    <div class="dialog-header">
        <h3>{{ data.title }}</h3>
        <div class="header-close">
            <button mat-icon-button color="primary" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <div class="content-content">
            <div class="content-description" [innerHTML]="data.description"></div>
            <span [innerHTML]="data.question"></span>
        </div>
        <div class="content-action" *ngIf="data.reasons$">
            <div class="default-form-field">
                <mat-label>{{ 'OVERVIEW.DIALOG.DELETE_OFFER.REASON' | translate }}</mat-label>
                <mat-form-field appearance="outline">
                    <mat-select [(value)]="reason">
                        <mat-option *ngFor="let available of availableReasons$ | async" [value]="available">
                            {{ available.displayValue }}
                        </mat-option>
                    </mat-select>
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </mat-form-field>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-stroked-button mat-dialog-close color="primary">{{ data.no }}</button>
        <button
            mat-flat-button
            color="primary"
            [mat-dialog-close]="reason?.value || true"
            [disabled]="data.reasons$ && !reason"
        >
            {{ data.yes }}
        </button>
    </mat-dialog-actions>
</div>
